module.exports = __webpack_public_path__ + "images/emoji/hibiscus.3e89104fe87427f28dad.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hibiscus.png
// module id = dOcf
// module chunks = 13